import {
  getPlatform,
  getStoreCode
} from "../../state/modules/config/selectors";
import { MOBILE, FLOOR_MEN } from "../../state/modules/config/constants";
import commonConfig from "../../config/common";

export const getAdUnitPath = (state, pageType, floorSelector) => {
  const {
    adverts: { networkCodeAndEnvPrefix }
  } = commonConfig;
  const platform = getPlatform(state) === MOBILE ? "MWEB" : "WEB";
  const storeCode = getStoreCode(state);
  const gender = floorSelector(state) === FLOOR_MEN ? "MW" : "WW";

  return `/${networkCodeAndEnvPrefix}/${platform}/${storeCode}/${gender}/${pageType}`;
};
